export default {"src":"/_next/static/media/chevronRightUiRed_24.31a69d62.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};